import React from "react";
import { Button, Spin } from "antd";
import blocksConverter from "@Components/shared/RichTextEditor/blocksConverter";
import "@Styles/components/accountPrivacy.scss";
import { CheckCircle } from "@mui/icons-material";
import BaseModal from "@Components/shared/BaseModal";
import { ITermPrompt } from "@Models/ITerms";

interface TermsModalProps {
    visible: boolean;
    isLoading?: boolean;
    onClose: () => void;
    termsContent: string;
    title: string;
    termsVersionId?: string;
    termsPrompt?: ITermPrompt;
    onAgree?: (termsVersionId: string, termsPrompt: ITermPrompt) => void;
    termsAlreadyAccepted?: boolean;
    isCreatingTermsAction?: boolean;
    showFooter?: boolean;
}

const TermsModal: React.FC<TermsModalProps> = ({
    visible,
    isLoading,
    onClose,
    termsContent,
    title,
    termsVersionId,
    termsPrompt,
    onAgree,
    termsAlreadyAccepted,
    isCreatingTermsAction,
    showFooter,
}) => {
    const handleAgree = () => {
        if (termsVersionId && onAgree && !termsAlreadyAccepted) {
            onAgree(termsVersionId, termsPrompt);
        }
    };

    const footer = showFooter ? (
        <div className="terms-modal-footer">
            {termsAlreadyAccepted ? (
                <div className="terms-accepted-text">
                    <CheckCircle />
                    Terms accepted
                </div>
            ) : (
                <Button key="agree" onClick={handleAgree} className="dark" loading={isCreatingTermsAction}>
                    Agree
                </Button>
            )}
        </div>
    ) : null;

    return (
        <BaseModal
            visible={visible}
            onClose={onClose}
            title={
                <div className="terms-modal-title">
                    <span>{title}</span>
                </div>
            }
            footer={footer}
            bodyStyle={{ maxHeight: "60vh", overflowY: "auto", paddingLeft: "70px", paddingRight: "70px" }}
            width={800}
            closable={false}
            className="terms-modal"
        >
            {isLoading ? <Spin /> : blocksConverter({ data: termsContent })}
        </BaseModal>
    );
};

export default TermsModal;
